/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard (C) Copyright IBM Corp. 2020, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([], function () {

	const OVERFLOW_ICON = 'overflowVertical';

	const ACTION_ICONS = {
		'#common-add-new': 'add16',
		'#common-menuoverflow': OVERFLOW_ICON
	};

	const ACTION_ERROR_TOKENS = [
		'warning',
		'error'
	];

	const ACTION_WARNING_EXTERNAL_ID = 'minor-warning';
	const ACTION_ERROR_EXTERNAL_ID = 'critical';

	const DATA_SOURCE_ICONS = {
		'module': 'common-titan-model',
		'uploadedFile': 'common-upload',
		'DEFAULT': 'common-dataset'
	};

	class DataSourcePanelIconHelper  {
		constructor({ iconsFeature }) {
			this.iconsFeature = iconsFeature;
		}

		// General-purpose functions
		getIcon(externalId) {
			return this.iconsFeature.getIcon(externalId);
		}

		getIconInternalId(externalId) {
			const icon = this.getIcon(externalId);
			return icon && icon.id;
		}

		getOverflowIcon() {
			return this.getIcon(OVERFLOW_ICON);
		}

		// Data source-specific functions
		getActionIconId(glassIconId) {
			const externalId = (
				ACTION_ICONS[glassIconId] ||
				(
					ACTION_ERROR_TOKENS.indexOf(glassIconId) >= 0 &&
					ACTION_WARNING_EXTERNAL_ID
				)
			);

			return externalId && this.getIconInternalId(externalId);
		}

		getDataSourceIcon(dataSourceType) {
			const externalId = DATA_SOURCE_ICONS[dataSourceType] || DATA_SOURCE_ICONS.DEFAULT;
			return this.getIconInternalId(externalId);
		}

		getDataSourceWarningIcon() {
			return this.getIconInternalId(ACTION_WARNING_EXTERNAL_ID);
		}

		getDataSourceErrorIcon() {
			return this.getIconInternalId(ACTION_ERROR_EXTERNAL_ID);
		}
	}

	return DataSourcePanelIconHelper;
});
